import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { PurchasesFilter } from "./PurchasesFilter";
import { PurchasesList } from "./PurchasesList";

// Компоновка раздела как у features/users: FilterProvider → Stack →
// карточка фильтров → список.
export const Purchases: FC = () => {
  return (
    <FilterProvider>
      <Stack spacing={1}>
        <PurchasesFilter />
        <PurchasesList />
      </Stack>
    </FilterProvider>
  );
};
